function v(n, t) {
  const c = t[0], o = t[1];
  return [
    n[0] * c + n[2] * o + n[4],
    n[1] * c + n[3] * o + n[5]
  ];
}
function D() {
  return [1, 0, 0, 1, 0, 0];
}
function p(n, t) {
  const c = n[0], o = n[1], i = n[2], e = n[3], s = n[4], u = n[5], T = t[0], M = t[1], h = t[2], b = t[3], l = t[4], f = t[5];
  return [
    c * T + i * M,
    o * T + e * M,
    c * h + i * b,
    o * h + e * b,
    c * l + i * f + s,
    o * l + e * f + u
  ];
}
function a(n, t) {
  const c = Math.cos(t), o = Math.sin(t);
  return p(n, [c, o, -o, c, 0, 0]);
}
function j(n, t, c) {
  return p(n, [t, 0, 0, c, 0, 0]);
}
function k(n, t, c) {
  return p(n, [1, 0, 0, 1, t, c]);
}
function q(n, t, c, o, i, e, s) {
  const u = Math.sin(i), T = Math.cos(i);
  return [
    c * T,
    o * u,
    -c * u,
    o * T,
    e * c * T - s * c * u + n,
    e * o * u + s * o * T + t
  ];
}
function r(n) {
  const t = d(n), c = n[0], o = n[1], i = n[2], e = n[3], s = n[4], u = n[5];
  return [
    e / t,
    -o / t,
    -i / t,
    c / t,
    (i * u - e * s) / t,
    -(c * u - o * s) / t
  ];
}
function d(n) {
  return n[0] * n[3] - n[1] * n[2];
}
function w(n) {
  const t = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
  return t[0] = n[0], t[1] = n[1], t[4] = n[2], t[5] = n[3], t[12] = n[4], t[13] = n[5], t;
}
export {
  v as applyTransform,
  q as composeTransform,
  D as createTransform,
  d as getDeterminant,
  r as invertTransform,
  p as multiplyTransform,
  a as rotateTransform,
  j as scaleTransform,
  w as transformToMatrix4,
  k as translateTransform
};
//# sourceMappingURL=matrix.js.map
